module.exports = __webpack_public_path__ + "static/media/typewriter.e694d801.png";